import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./panel/Header";
import Slider from "./panel/Sidebar";
import Foother from "./panel/foother";


function Layout() {
  return (
    <div className="panel-body" >
      {/* هدر ثابت */}  
      <Header />

      {/* محتوای متغیر */}
      
        <Outlet />
      

      {/* فوتر ثابت */}
         <Slider />
         <Foother />
    </div>
  );
}

export default Layout;
